import { EducationRoute } from '@/modules/education/v1/api/EducationRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { GetQuestionsParams } from '@/modules/education/v1/api/v1/questions/Dto/GetQuestionsParams'
import { QuestionsResponse } from '@/modules/education/v1/api/v1/questions/Dto/QuestionsResponse'
import { OFFLINE_NODE, OFFLINE_QUESTION } from '@/modules/education/v1/api/v1/packs/GetPack/GetPackRoute'

/** GET /api/education/v1/questions[?node=uuid]: вопросы пользователя с состоянием расписания */
export class GetQuestionsRoute extends EducationRoute<GetQuestionsParams, QuestionsResponse> {
  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/education/v1/questions'
  }

  offline(params: GetQuestionsParams): Promise<ApiResponse<QuestionsResponse>> {
    const node = params.node ?? OFFLINE_NODE
    const createdAt = new Date().toISOString()
    return Promise.resolve(new ApiResponse({
      success: true,
      data: new QuestionsResponse({
        questions: [{
          uuid: OFFLINE_QUESTION, node, weight: 3, key: '', data: '', createdAt, removedAt: null,
          schedule: { streak: 0, interval: 3600, dueAt: createdAt, asked: 0, correct: 0 },
        }],
      }),
    }))
  }
}
